// Theme: steel-horizon
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'steel-horizon',
  name: 'STEEL HORIZON',
  tagline: 'STEEL HORIZON',
  description: 'Azul de aco com leitura limpa e rare glow controlado.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0D1520', '#93C5FD', '#1A2535', '#E0F2FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)'
    },
    shellClasses: 'font-sans theme-steel-horizon'
  },
  colorVars: {
    '--accent': '#93C5FD',
    '--accent-foreground': '#0D1520',
    '--background': '#0D1520',
    '--border': '#3A5A7A',
    '--card': '#1A2535',
    '--card-border-active': 'rgba(147, 197, 253, 0.42)',
    '--card-completed': '#1A2535',
    '--card-foreground': '#E0F2FE',
    '--card-glow': 'rgba(147, 197, 253, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0D1520',
    '--foreground': '#E0F2FE',
    '--hold-fill': '#93C5FD',
    '--input': '#1A2535',
    '--modal-bg': '#0D1520',
    '--modal-border': '#3A5A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5A7A',
    '--muted-foreground': '#E0F2FE',
    '--nav-active': '#93C5FD',
    '--nav-bg': '#0D1520',
    '--popover': '#1A2535',
    '--popover-foreground': '#E0F2FE',
    '--primary': '#93C5FD',
    '--primary-foreground': '#0D1520',
    '--ring': '#93C5FD',
    '--secondary': '#3A5A7A',
    '--secondary-foreground': '#E0F2FE',
    '--streak': '#93C5FD',
    '--success': '#22C55E',
    '--success-foreground': '#0D1520',
    '--xp': '#93C5FD',
    '--xp-bg': '#1A2535'
  },
  resolvedVars: {
    '--accent': '#93C5FD',
    '--accent-foreground': '#0D1520',
    '--accent-foreground-hsl': '215 42% 9%',
    '--accent-foreground-oklch': 'from #0D1520 l c h',
    '--accent-hsl': '212 96% 78%',
    '--accent-oklch': 'from #93C5FD l c h',
    '--background': '#0D1520',
    '--background-hsl': '215 42% 9%',
    '--background-oklch': 'from #0D1520 l c h',
    '--border': '#3A5A7A',
    '--border-hsl': '210 36% 35%',
    '--border-oklch': 'from #3A5A7A l c h',
    '--border-w': '1px',
    '--card': '#1A2535',
    '--card-border-active': 'rgba(147, 197, 253, 0.42)',
    '--card-completed': '#1A2535',
    '--card-completed-hsl': '216 34% 15%',
    '--card-completed-oklch': 'from #1A2535 l c h',
    '--card-foreground': '#E0F2FE',
    '--card-foreground-hsl': '204 94% 94%',
    '--card-foreground-oklch': 'from #E0F2FE l c h',
    '--card-glow': 'rgba(147, 197, 253, 0.08)',
    '--card-hsl': '216 34% 15%',
    '--card-oklch': 'from #1A2535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0D1520',
    '--destructive-foreground-hsl': '215 42% 9%',
    '--destructive-foreground-oklch': 'from #0D1520 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#E0F2FE',
    '--foreground-hsl': '204 94% 94%',
    '--foreground-oklch': 'from #E0F2FE l c h',
    '--hold-fill': '#93C5FD',
    '--hold-fill-hsl': '212 96% 78%',
    '--hold-fill-oklch': 'from #93C5FD l c h',
    '--input': '#1A2535',
    '--input-hsl': '216 34% 15%',
    '--input-oklch': 'from #1A2535 l c h',
    '--modal-bg': '#0D1520',
    '--modal-bg-hsl': '215 42% 9%',
    '--modal-bg-oklch': 'from #0D1520 l c h',
    '--modal-border': '#3A5A7A',
    '--modal-border-hsl': '210 36% 35%',
    '--modal-border-oklch': 'from #3A5A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5A7A',
    '--muted-foreground': '#E0F2FE',
    '--muted-foreground-hsl': '204 94% 94%',
    '--muted-foreground-oklch': 'from #E0F2FE l c h',
    '--muted-hsl': '210 36% 35%',
    '--muted-oklch': 'from #3A5A7A l c h',
    '--nav-active': '#93C5FD',
    '--nav-active-hsl': '212 96% 78%',
    '--nav-active-oklch': 'from #93C5FD l c h',
    '--nav-bg': '#0D1520',
    '--nav-bg-hsl': '215 42% 9%',
    '--nav-bg-oklch': 'from #0D1520 l c h',
    '--popover': '#1A2535',
    '--popover-foreground': '#E0F2FE',
    '--popover-foreground-hsl': '204 94% 94%',
    '--popover-foreground-oklch': 'from #E0F2FE l c h',
    '--popover-hsl': '216 34% 15%',
    '--popover-oklch': 'from #1A2535 l c h',
    '--primary': '#93C5FD',
    '--primary-foreground': '#0D1520',
    '--primary-foreground-hsl': '215 42% 9%',
    '--primary-foreground-oklch': 'from #0D1520 l c h',
    '--primary-hsl': '212 96% 78%',
    '--primary-oklch': 'from #93C5FD l c h',
    '--radius': '12px',
    '--ring': '#93C5FD',
    '--ring-hsl': '212 96% 78%',
    '--ring-oklch': 'from #93C5FD l c h',
    '--secondary': '#3A5A7A',
    '--secondary-foreground': '#E0F2FE',
    '--secondary-foreground-hsl': '204 94% 94%',
    '--secondary-foreground-oklch': 'from #E0F2FE l c h',
    '--secondary-hsl': '210 36% 35%',
    '--secondary-oklch': 'from #3A5A7A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)',
    '--streak': '#93C5FD',
    '--streak-hsl': '212 96% 78%',
    '--streak-oklch': 'from #93C5FD l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0D1520',
    '--success-foreground-hsl': '215 42% 9%',
    '--success-foreground-oklch': 'from #0D1520 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(212 96% 78% / 0.15)',
    '--xp': '#93C5FD',
    '--xp-bg': '#1A2535',
    '--xp-bg-hsl': '216 34% 15%',
    '--xp-bg-oklch': 'from #1A2535 l c h',
    '--xp-hsl': '212 96% 78%',
    '--xp-oklch': 'from #93C5FD l c h'
  }
}
